import { MouseEvent, KeyboardEvent } from "react";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { postVPNAuthKeySupportSessionUseCase } from "@src/cloud-connect/vpn-manager/use-cases/vpn-post-generate-auth-key-support-session-use-case";
import { vncWebsocketUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { openVncTab, sendVncKey } from "@src/cloud-connect/vnc/utils/open-vnc";
import type { NoVncVersion } from "@src/cloud-connect/vnc/utils/novnc-loader";

interface HandleActiveSupportSessionButtonClickParams {
  e?: MouseEvent | KeyboardEvent;
  setLoading: (isLoading: boolean) => void;
  novncVersion?: NoVncVersion;
  swapRB?: boolean;
  getAuthKey?: typeof postVPNAuthKeySupportSessionUseCase;
  machine: {
    namespace?: string;
    id?: string;
    machine_id: string;
    name?: string;
    remaining_duration?: string | null;
  };
  isConnected: boolean;
}

export const handleActiveSupportSessionButtonClick = async ({
  e,
  setLoading,
  machine,
  isConnected,
  novncVersion = "1.3.0",
  swapRB = false,
  getAuthKey = postVPNAuthKeySupportSessionUseCase,
}: HandleActiveSupportSessionButtonClickParams) => {
  setLoading(true);
  e?.stopPropagation();

  // Open VNC synchronously during the user gesture to avoid popup blocking.
  const vncTab = openVncTab({
    machineId: machine.machine_id,
    sourceName: machine.name,
    sourceStatus: isConnected ? "CONNECTED" : "DISCONNECTED",
    duration: machine.remaining_duration,
    sessionId: machine.id,
    namespace: machine.namespace,
    novncVersion,
    swapRB,
  });

  try {
    const res = await getAuthKey({
      namespace: machine.namespace,
      id: machine.id,
    });

    if (!res.success || !res.data?.websocket_auth_key) {
      errorSnackbar(res.error);
      vncTab?.close();
      return;
    }

    if (vncTab) {
      sendVncKey(
        vncTab,
        machine.id,
        `${vncWebsocketUrlEnvVar()}/api/v1/vnc/${res.data.websocket_auth_key}`,
      );
    }
  } catch (error) {
    errorSnackbar(error instanceof Error ? error.message : undefined);
    vncTab?.close();
  } finally {
    setLoading(false);
  }
};
